import {BlankState, BlankUserData, BlankDictionary} from './stateParts'
import {RunStates} from './runStates'
import {toUserDictionaryObjForm} from '../js/toUserDictionaryObjForm'

function propertyValidateSimple (savedStateParent, blankStateParent, property) {
  if (!(Object.prototype.hasOwnProperty.call(savedStateParent, property))
      || (typeof savedStateParent[property] !== typeof blankStateParent[property])) {
    savedStateParent[property] = blankStateParent[property]
  }
}

const FIREBASE_KEY_BADCHARS = [".", "#", "$", "/", "[", "]", "\n"]

export default {
  validateState: (savedState) => {
    var savedStateVersion = null
    var validationResult = { failures: [] }
    // (1) ensure presence of all root properties (and validate two)
    Object.keys(BlankState).forEach(rootProp => {
      if (['isLoggedIn', 'loginInProgress'].includes(rootProp)) { // CHANGE TO ACCOUNT!
        propertyValidateSimple(savedState, BlankState, rootProp)
      } else if (!(Object.prototype.hasOwnProperty.call(savedState, rootProp))) savedState[rootProp] = BlankState[rootProp]
    })
    if (Object.prototype.hasOwnProperty.call(savedState, 'version')) { // 'version' introduced in version 1.1
      savedStateVersion = savedState.version
      delete savedState.version
    } else savedStateVersion = Object.prototype.hasOwnProperty.call(savedState.allWorkingNikud, 'lastWordId') ? '1.0.1' : '1.0'
    // (2) ensure presence of all preSubmissionOptions and postSubmissionOptions
    const submissionOptionListNames = ['preSubmissionOptions', 'postSubmissionOptions']
    submissionOptionListNames.forEach(listName => {
      if (typeof savedState[listName] === 'object' && savedState[listName] !== null) {
        Object.keys(BlankState[listName]).forEach(option => { 
          propertyValidateSimple(savedState[listName], BlankState[listName], option)
        })
      }
    })
    // (3) validate 'originalDocument'
    if (typeof savedState.originalDocument === 'object' && savedState.originalDocument !== null) {
      propertyValidateSimple(savedState.originalDocument, BlankState.originalDocument, 'id')
      propertyValidateSimple(savedState.originalDocument, BlankState.originalDocument, 'text')
      if (Object.prototype.hasOwnProperty.call(savedState.originalDocument, 'source')
          && typeof savedState.originalDocument.source === 'object' && savedState.originalDocument.source !== null
          && Object.prototype.hasOwnProperty.call(savedState.originalDocument.source, 'type')
          && ['text', 'docx'].includes(savedState.originalDocument.source.type)) {
        if (savedState.originalDocument.source.type === 'docx') { // 'text' currently needs no further validation
          if (!(Object.prototype.hasOwnProperty.call(savedState.originalDocument.source, 'fileBase64Contents'))
              || (typeof savedState.originalDocument.source.fileBase64Contents !== 'string')) {
            validationResult.failures.push({
              failureType: "originalDocument 'docx' but no 'fileBase64Contents' string"
            })
          }
          const wordToRunAndPosMapElementProps = ['wordIndex', 'runIndex', 'startPos','endPos']
          if (!(Object.prototype.hasOwnProperty.call(savedState.originalDocument.source, 'wordToRunAndPosMap'))
              || !(Array.isArray(savedState.originalDocument.source.wordToRunAndPosMap))
              || !(savedState.originalDocument.source.wordToRunAndPosMap.every(e => 
                typeof e === 'object' && e !== null 
                  && wordToRunAndPosMapElementProps.every(p =>
                    Object.prototype.hasOwnProperty.call(e, p) && typeof e[p] === 'number')))) {
            validationResult.failures.push({
              failureType: "originalDocument 'docx' but no valid 'wordToRunAndPosMap' array"
            })
          }
          if (!(Object.prototype.hasOwnProperty.call(savedState.originalDocument.source, 'wordToRunAndPosMap'))
              || !(Array.isArray(savedState.originalDocument.source.wordToRunAndPosMap))
              || !(savedState.originalDocument.source.wordToRunAndPosMap.length)) {
            if (!(Object.prototype.hasOwnProperty.call(savedState.originalDocument.source, 'runArray'))
                || !(Array.isArray(savedState.originalDocument.source.runArray))) {
              validationResult.failures.push({
                failureType: "originalDocument 'docx' but no 'runArray' array"
              })
            } else if (!(savedState.originalDocument.source.runArray.every(e => typeof e === 'string'))
                      || (savedState.originalDocument.source.runArray.join('').replace(/\n/g, '')
                      !== savedState.originalDocument.text.replace(/\n/g, ''))) {
              validationResult.failures.push({
                failureType: "originalDocument 'docx' but runArray doesn't correspond to text"
              })
            }
          }
        }
      } else savedState.originalDocument.source = BlankState.originalDocument.source
      if (!(Object.prototype.hasOwnProperty.call(savedState.originalDocument, 'identifiedGenre'))) {
        savedState.originalDocument['identifiedGenre'] = BlankState.originalDocument.identifiedGenre
      }
    } else savedState.originalDocument = BlankState.originalDocument
    // (4) validate remaining 'simple' parts of state
    const runStateNames = ['nakdanApiState', 'genreClassifyApiState']
    runStateNames.forEach(runStateName => {
      if (!(typeof savedState[runStateName] === 'string'
          || !(Object.values(RunStates).includes(savedState[runStateName])))) {
        /* validationResult.failures.push({
          failureType: "'" + runStateName + "' not a valid 'RunStates' string"
        }) */
        savedState[runStateName] = BlankState[runStateName]
      }
    })
    if (typeof savedState.wordIdToIndexMap !== 'object' || savedState.wordIdToIndexMap === null) {
      savedState.wordIdToIndexMap = {}
    }
    // PRELIMINARY check of allWorkingNikud and .wordsArray, and 'version 1.0 check'
    propertyValidateSimple(savedState.allWorkingNikud, BlankState.allWorkingNikud, 'id')
    if (typeof savedState.allWorkingNikud !== 'object' || savedState.allWorkingNikud === null
        || !(Object.prototype.hasOwnProperty.call(savedState.allWorkingNikud, 'wordsArray'))) {
      savedState.allWorkingNikud = BlankState.allWorkingNikud
    }
    if (!(Array.isArray(savedState.allWorkingNikud.wordsArray))
        || !(savedState.allWorkingNikud.wordsArray.every(e => typeof e === 'object' && e !== null))) {
      validationResult.failures.push({
        failureType: "'allWorkingNikud.wordsArray' not an array of objects"
      })
      savedState.allWorkingNikud.wordsArray = BlankState.allWorkingNikud.wordsArray // 'temporarily'
    } else if (savedStateVersion.slice(0, 3) === '1.0') {
      savedState.allWorkingNikud.wordsArray.forEach((wordObj, w) => {
        wordObj['wordId'] = w
        savedState.wordIdToIndexMap[w] = w
      })
      savedState.allWorkingNikud['lastWordId'] = savedState.allWorkingNikud.wordsArray.length - 1
    } else if (typeof savedState.wordIdToIndexMap !== 'object' || savedState.wordIdToIndexMap === null) 
    // back to validating remaining 'simple' parts of state
    if (!(typeof savedState.currentPositionData !== 'object'
        || savedState.currentPositionData === null)
        || !(Object.prototype.hasOwnProperty.call(savedState.currentPositionData, 'wordIndex'))
        || typeof savedState.currentPositionData.wordIndex !== 'number'
        || savedState.currentPositionData.wordIndex < -1
        || savedState.currentPositionData.wordIndex >= savedState.allWorkingNikud.wordsArray.length) {
      savedState.currentPositionData = BlankState.currentPositionData
    }
    if (!(Object.prototype.hasOwnProperty.call(savedState.currentPositionData, 'letterIndex'))
        || typeof savedState.currentPositionData.letterIndex !== 'number'
        || savedState.currentPositionData.letterIndex < -1
        || savedState.currentPositionData.wordIndex === -1
        || !(Object.prototype.hasOwnProperty.call(savedState.allWorkingNikud.wordsArray[savedState.currentPositionData.wordIndex], 'sepBefore'))
        || typeof savedState.allWorkingNikud.wordsArray[savedState.currentPositionData.wordIndex].sepBefore !== 'string') {
      savedState.currentPositionData.letterIndex = BlankState.currentPositionData.letterIndex
    } else savedState.currentPositionData.letterIndex = savedState.allWorkingNikud.wordsArray[savedState.currentPositionData.wordIndex].sepBefore.length // for now, easier than trying to getChosenWord length
    if (savedState.account && typeof savedState.account === 'object') {
      if (typeof savedState.account.userData !== 'object'
          || (savedState.account.userData !== null
              && (!(Object.prototype.hasOwnProperty.call(savedState.account.userData, 'name'))
                  || typeof savedState.account.userData.name !== 'string'
                  || !(Object.prototype.hasOwnProperty.call(savedState.account.userData, 'email'))
                  || typeof savedState.account.userData.email !== 'string'))) {
        validationResult.failures.push({
          failureType: "'userData' invalid"
        })
        // console.log('JSON.stringify(savedState.account.userData):')
        // console.log(JSON.stringify(savedState.account.userData))
        savedState.account.userData = BlankUserData // at least 'temporarily'
      }
      if (!(savedState.account.userData)) {
        if (savedState.account.sync && savedState.account.sync.dictionary
            && Object.prototype.hasOwnProperty.call(savedState.userDictionary, 'entryPresent') 
            && typeof savedState.account.sync.dictionary.entryPresent === 'object'
            && savedState.account.sync.dictionary.entryPresent !== null
            && Object.keys(savedState.account.sync.dictionary.entryPresent).length === 0) {
          validationResult.failures.push({
            failureType: "found 'userDictionary' data without (valid) 'userData'"
          })
        }
        if (savedState.account.sync) savedState.account.sync.dictionary = JSON.parse(JSON.stringify(BlankDictionary)) // at least 'temporarily'
      } else if ((Object.prototype.hasOwnProperty.call(savedState.account, 'sync')
                      && (!(savedState.account.sync) || typeof savedState.account.sync !== 'object'))
                  || (Object.prototype.hasOwnProperty.call(savedState.account.sync, 'dictionary')
                      && (!(savedState.account.sync.dictionary) || typeof savedState.account.sync.dictionary !== 'object'
                          || (savedStateVersion.slice(0, 3) < '1.3' // invalidates alone, b/c we're not "creating" .account
                          || !(Object.prototype.hasOwnProperty.call(savedState.account.sync.dictionary, 'entryPresent'))
                          || typeof savedState.account.sync.dictionary.entryPresent !== 'object'
                          || savedState.account.sync.dictionary.entryPresent === null
                          || !(Object.values(savedState.account.sync.dictionary.entryPresent).every(e => e === true))
                          || !(Object.prototype.hasOwnProperty.call(savedState.account.sync.dictionary, 'lettersMap'))
                          || typeof savedState.account.sync.dictionary.lettersMap !== 'object'
                          || savedState.account.sync.dictionary.lettersMap === null
                          || !(Object.values(savedState.account.sync.dictionary.lettersMap)
                                    .every(a => Array.isArray(a) 
                                                && a.every(e => typeof e === 'string'
                                                                && FIREBASE_KEY_BADCHARS.every(badChar => !(e.includes(badChar))))))
                          || !(Object.prototype.hasOwnProperty.call(savedState.account.sync.dictionary, 'negativeEntryPresent'))
                          || typeof savedState.account.sync.dictionary.negativeEntryPresent !== 'object'
                          || savedState.account.sync.dictionary.negativeEntryPresent === null
                          || !(Object.values(savedState.account.sync.dictionary.negativeEntryPresent).every(e => e === true))
                          || !(Object.prototype.hasOwnProperty.call(savedState.account.sync.dictionary, 'negativeLettersMap'))
                          || typeof savedState.account.sync.dictionary.negativeLettersMap !== 'object'
                          || savedState.account.sync.dictionary.negativeLettersMap === null
                          || !(Object.values(savedState.account.sync.dictionary.negativeLettersMap)
                                    .every(a => Array.isArray(a)
                                                && a.every(e => typeof e === 'string'
                                                                && FIREBASE_KEY_BADCHARS.every(badChar => !(e.includes(badChar)))))))))) {
        // console.log('JSON.stringify(savedState.account.sync.dictionary):')
        // (rewrite) console.log(JSON.stringify(savedState.account.sync.dictionary))
        // console.log('savedStateVersion:')
        // console.log(savedStateVersion)
        validationResult.failures.push({
          failureType: "invalid 'userDictionary' data"
        })
        if (savedState.account.sync) savedState.account.sync.dictionary = JSON.parse(JSON.stringify(BlankDictionary)) // 'temporarily'
      } else {
        if (savedStateVersion.slice(0, 3) < '1.3') {
          savedState.userDictionary = toUserDictionaryObjForm(savedState.userDictionary, [])
        }
        if (!((savedState.account && savedState.account.isLoggedIn)
              || (savedState.account && savedState.account.loginInProgress))) {
          validationResult.failures.push({
            failureType: "found valid 'userData' but 'isLoggedIn' and 'loginInProgress' both false"
          })
        }
      }
    }
    // (5) validate 'nakdanApiResponse' and 'allWorkingNikud.wordsArray'
    if (!(Array.isArray(savedState.nakdanApiResponse)) // NOTE: this is only a partial test (structure and types)
        || !(savedState.nakdanApiResponse.every(e =>
            typeof e === 'object' && e !== null
            && Object.prototype.hasOwnProperty.call(e, 'options') && Array.isArray(e.options)
            && e.options.every(o => typeof o === 'string') // current response from abbr server (temp?)
            && Object.prototype.hasOwnProperty.call(e, 'sep') && typeof e.sep === 'boolean'
            // (fpasuk NOT mandatory) && (e.sep || (Object.prototype.hasOwnProperty.call(e, 'fpasuk') && typeof e.fpasuk === 'boolean'))
            && Object.prototype.hasOwnProperty.call(e, 'word') && typeof e.word === 'string'))) {
      validationResult.failures.push({
        failureType: "invalid 'nakdanApiResponse' data"
      })
      savedState.nakdanApiResponse = BlankState.nakdanApiResponse // 'temporarily'
    }
    if (!(savedState.allWorkingNikud.wordsArray.every(w =>
        typeof w === 'object' && w !== null
        && Object.prototype.hasOwnProperty.call(w, 'options') && Array.isArray(w.options)
        && w.options.every(o => // currently skipping o.prefixEndIndex since we don't use it (yet)
          typeof o === 'object' && o !== null
          && Object.prototype.hasOwnProperty.call(o, 'displayText') && typeof o.displayText === 'string')
        && Object.prototype.hasOwnProperty.call(w, 'altered') && typeof w.altered === 'boolean'
        && Object.prototype.hasOwnProperty.call(w, 'choiceType') && typeof w.choiceType === 'string'
        && Object.prototype.hasOwnProperty.call(w, 'editedNikud') && typeof w.editedNikud === 'string'
        && Object.prototype.hasOwnProperty.call(w, 'manualNikud') && typeof w.manualNikud === 'string'
        && Object.prototype.hasOwnProperty.call(w, 'originalWord') && typeof w.originalWord === 'string'
        && Object.prototype.hasOwnProperty.call(w, 'sepBefore') && typeof w.sepBefore === 'string'
        && Object.prototype.hasOwnProperty.call(w, 'sepAfter') && typeof w.sepAfter === 'string'
        && Object.prototype.hasOwnProperty.call(w, 'chosenOptionIndex') && typeof w.chosenOptionIndex === 'number'
        ))) {
      validationResult.failures.push({
        failureType: "some of 'wordsArray' (at least) invalid"
      })
      savedState.allWorkingNikud.wordsArray = BlankState.allWorkingNikud.wordsArray // 'temporarily'
    }
    var usedWordIds = []
    var nextNewWordIdToGive = savedState.allWorkingNikud.wordsArray.length // for duplicates start after "good" olds
    savedState.wordIdToIndexMap = {} // it's simpler to rebuild the map than to test the old one
    savedState.allWorkingNikud.wordsArray.forEach((wordObj, w) => {
      if (Object.prototype.hasOwnProperty.call(wordObj, 'htmlIfNotCurrent')) delete wordObj.htmlIfNotCurrent
      // simpler to recalc ChosenString & LetterArray than to test, SO NOW DOING IT IN BUILD_STATE
      if (!(Object.prototype.hasOwnProperty.call(wordObj, 'wordId')) || typeof wordObj.wordId !== 'number' 
          || usedWordIds.includes(wordObj.wordId)) { // i.e. duplicate (or no valid) wordId found!
        if (usedWordIds.includes(w)) {
          while (usedWordIds.includes(nextNewWordIdToGive)) nextNewWordIdToGive ++ // in case it's been used since
          wordObj.wordId = nextNewWordIdToGive ++ // increment after assignment (for next time)
        } else wordObj.wordId = w
      }
      savedState.wordIdToIndexMap[wordObj.wordId] = wordObj.wordId
      if (!(Object.prototype.hasOwnProperty.call(wordObj, 'specialData'))
          || typeof wordObj.specialData !== 'object' || wordObj.specialData === null) wordObj['specialData'] = {}
    })
    savedState.allWorkingNikud.lastWordId = savedState.allWorkingNikud.wordsArray.length - 1
    const fakeFailure = false
    if (validationResult.failures.length || fakeFailure) {
      validationResult['summary'] = 'failure'
    } else validationResult['summary'] = 'success'
    return validationResult
  }
}
